const keyGenerator = (firstAuthor, title, date) => {
    const part1 = firstAuthor.split(' ')[0];
    const part2 = date.toString().split(' ').pop();
    const part3 = title.split(' ')[0];

    const key = `${part1}${part2}${part3}`;

    return key;
};

const generator = (data, type) => {
    const authors = data.authors.map((author, authorIndex, arr) => {
        if (authorIndex === 0) return author;
        if (authorIndex === arr.length - 1) return ` and ${author}`;
        return ` ${author}`;
    });

    const { title } = data;
    const publisher = data.publisher ? data.publisher : '';

    if (type === 'journal') {
        const { year } = data;
        const { volume } = data;
        const { journal } = data;
        const key = keyGenerator(data.authors[0], title, year);

        const APA = `${authors}. ${title}. ${journal}, ${volume}. ${publisher}, ${year}`;

        const BIB = `@article{${key},
    title={${title}},
    author={${authors}},
    journal={${journal}},
    year={${year}},
    volume={${volume}},
    publisher={${publisher}}
}`;

        return { APA, BIB };
    }

    if (type === 'conference') {
        const { date } = data;
        const { pages } = data;
        const { conference, conferenceShort } = data;
        const { location } = data;
        const key = keyGenerator(data.authors[0], title, date);

        const APA = `${authors}. ${title}. In ${conference} (${conferenceShort}), pp. ${pages}. ${location}, ${date}. ${publisher}.`;

        const BIB = `@inproceedings{${key},
    title={${title}},
    author={${authors}},
    booktitle={${conference} (${conferenceShort})},
    year={${date}},
    pages={${pages}},
    organization={${publisher}}
}`;

        return { APA, BIB };
    }

    if (type === 'bookchapter') {
        const { year } = data;
        const { pages } = data;
        const { book } = data;
        const key = keyGenerator(data.authors[0], title, year);

        const APA = `${authors}. ${title}. ${book}, ${pages}. ${publisher}, ${year}`;

        const BIB = `@InBook{${key},
    title={${title}},
    author={${authors}},
    bookTitle={${book}},
    year={${year}},
    pages={${pages}},
    publisher={${publisher}}
}`;

        return { APA, BIB };
    }

    if (type === 'preprint') {
        const { year } = data;
        const { preprint } = data;
        const key = keyGenerator(data.authors[0], title, year);

        const APA = `${authors}. ${title}. ${preprint}. ${year}`;

        const BIB = `@misc{${key},
    title={${title}},
    author={${authors}},
    year={${year}},
    eprint={${preprint}}
}`;

        return { APA, BIB };
    }

    if (type === 'patent') {
        const year = data.application.date;
        const { location } = data;
        const appNum = data.application.number;
        const key = keyGenerator(data.authors[0], title, year);

        const APA = `${authors}. ${title} (Application No. ${appNum}). ${location}. ${year}`;

        const BIB = `@misc{${key},
    title={${title} (Application No. ${appNum})},
    author={${authors}},
    year={${year}},
    publisher={${location}}
}`;

        return { APA, BIB };
    }

    return { APA: 'null', BIB: 'null' };
};

export default generator;
